import React, { useEffect, useState } from "react";
import { Stack } from "@chakra-ui/react";
import ReusableDrawer from "components/Drawers/ReusableDrawer";
import GradientButton from "components/Buttons/GradientButton";
import ReusableInput from "components/Inputs/ReusableInput";

const EditContactLogDrawer = ({ isOpen, onClose, log, onUpdate }) => {
  const [formData, setFormData] = useState({});

  useEffect(() => {
    if (log) setFormData(log);
  }, [log]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = () => {
    onUpdate(formData);
    onClose();
  };

  return (
    <ReusableDrawer
      isOpen={isOpen}
      onClose={onClose}
      headerContent={<h2>Edit Contact Log</h2>}
      bodyContent={
        <Stack spacing={4}>
          <ReusableInput label="Reason" name="reason" value={formData.reason || ""} onChange={handleChange} />
          <ReusableInput label="Notes" name="notes" value={formData.notes || ""} onChange={handleChange} />
          <ReusableInput label="Outcome" name="outcome" value={formData.outcome || ""} onChange={handleChange} />
          <ReusableInput label="Next Action" name="next_action" value={formData.next_action || ""} onChange={handleChange} />
          <ReusableInput
            label="Follow Up Date"
            name="follow_up_date"
            type="date"
            value={formData.follow_up_date || ""}
            onChange={handleChange}
          />
        </Stack>
      }
      footerContent={
        <Stack direction="row" justify="flex-end">
          <GradientButton onClick={onClose} height="37px">Cancel</GradientButton>
          <GradientButton onClick={handleSubmit}  height="37px">Update</GradientButton>
        </Stack>
      }
    />
  );
};

export default EditContactLogDrawer;